<script>
    export let displayName;
    export let photoURL;
    export let uid;
    import { createEventDispatcher } from 'svelte';
    const dispatch = createEventDispatcher();
    
</script>
<style>
  article {
    margin: 40px auto 20px;
  }
</style>


<article class="media is-centered">
  <figure class="media-left">
    <p class="image is-64x64">
      <img src={ photoURL } alt="Profile">
    </p>
  </figure>
  <div class="media-content">
    <div class="content">
      <p>
        <strong>{ displayName }</strong> <small>Your userID is { uid }</small>
        <br>
        Hello { displayName }!
      </p>
    </div>
  </div>
  <div class="media-right">
    <button on:click={ () => dispatch('signout') } class="button">Logout</button>
  </div>
</article>

